import React, { PropsWithChildren, ReactNode } from 'react';
import { PureAlert } from './alert.component';


type OverlayProps = PropsWithChildren<{
  show?: boolean,
  overlayComponent?: ReactNode,
}>

export const Overlay: React.FC<OverlayProps> = ({ children, show, overlayComponent }: OverlayProps) => (
  <div className="overlay-with-component">
    {
      show && (
        <div className="overlay-with-component-text">
          { overlayComponent }
        </div>
      )
    }
    {children}
  </div>
);


type AlertOverlayProps = PropsWithChildren<{
  show?: boolean,
  message?: string,
  type: 'alert-warning' | 'alert-danger' | 'alert-info' | 'alert-success',
}>

export const AlertOverlay: React.FC<AlertOverlayProps> = ({ children, show, message, type }: AlertOverlayProps) => (
  <Overlay
    show={show}
    overlayComponent={
      <PureAlert
        type={type}
        content={message}
        show
      />
    }
  >
    {children}
  </Overlay>
);

